import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AbstractResolver } from '../../../shared/services/abstract-resolver';
import { TruckJourneyDetail } from '../models/truck-journey.model';
import { LoaderService } from '../../../shared/services/loader.service';
import { TruckJourneyService } from './truck-journey.service';

@Injectable()
export class TruckJourneyResolverService extends AbstractResolver<TruckJourneyDetail> {
  constructor(
    loaderService: LoaderService,
    private truckJourneyService: TruckJourneyService
  ) {
    super(loaderService);
  }

  protected doResolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TruckJourneyDetail> {
    return this.truckJourneyService.getTruckJourney(route.paramMap.get('id'));
  }
}
